import styles from './documenten.module.css'

export default () => (
    <p className={styles.p}>This should be red</p>
  )